module.exports = __webpack_public_path__ + "static/img/logo.dae35b8b.png";